import { noop } from '@flatbiz/utils';
import './base.less';
import './disabled.less';

export const styles = noop;
